import { generateAvatar } from '@/utils/avatar'
import { updateAvatarApi } from '@/api/auth'
import { uploadFileApi } from '@/api/file'

const state = {
  loginType: 'login',
  token: localStorage.getItem('token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  isLoggedIn: !!localStorage.getItem('token')
}

const mutations = {
  SET_LOGIN_TYPE: (state, type) => {
    state.loginType = type
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    state.isLoggedIn = !!token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    if (userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('userInfo')
    }
  },
  CLEAR_USER: (state) => {
    state.token = ''
    state.userInfo = {}
    state.isLoggedIn = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  // 登录
  async login({ commit }, { token, userInfo }) {
    // 先设置token，确保后续API调用有权限
    commit('SET_TOKEN', token)
    
    // 如果是新注册用户且没有头像，自动生成头像并保存到后端
    if (userInfo && !userInfo.avatar) {
      try {
        // 生成SVG头像
        const avatarSvg = generateAvatar(userInfo.email || userInfo.id || 'default')
        
        // 将SVG转换为Blob对象
        const blob = new Blob([avatarSvg], { type: 'image/svg+xml' })
        
        // 创建FormData并添加文件
        const formData = new FormData()
        formData.append('file', blob, 'avatar.svg')
        
        // 上传文件到服务器
        const uploadResponse = await uploadFileApi(formData)
        
        if (uploadResponse.code === 200 && uploadResponse.data) {
          // 获取文件URL，更新用户信息
          const avatarUrl = uploadResponse.data
          userInfo = {
            ...userInfo,
            avatar: avatarUrl
          }
          
          // 更新用户头像信息到后端
          await updateAvatarApi({ avatar: avatarUrl })
        } else {
          throw new Error('文件上传失败')
        }
      } catch (error) {
        console.error('头像上传和处理失败:', error)
        // 即使上传失败，也生成一个Data URL作为备用
        const avatarSvg = generateAvatar(userInfo.email || userInfo.id || 'default')
        const blob = new Blob([avatarSvg], { type: 'image/svg+xml' })
        const dataUrl = URL.createObjectURL(blob)
        userInfo = {
          ...userInfo,
          avatar: dataUrl
        }
      }
    }
    
    commit('SET_USER_INFO', userInfo)
    return Promise.resolve()
  },
  
  // 登出
  logout({ commit }) {
    commit('CLEAR_USER')
    return Promise.resolve()
  },
  
  // 重置token
  resetToken({ commit }) {
    commit('CLEAR_USER')
    return Promise.resolve()
  },
  
  // 更新用户信息
  updateUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
    return Promise.resolve()
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isLoggedIn: state => state.isLoggedIn,
  loginType: state => state.loginType
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
